import { ISoftDelete } from '@principle-theorem/shared';
import { IAutomationResource } from '../automation/automation';
import { IAutomatedNotification } from '../notification/automated-notification';
import { IGeneratedTask } from '../task/generated-task';

export enum MarketingCampaignStepStatus {
  Draft = 'draft',
  Active = 'active',
}

export enum MarketingCampaignStepConversionType {
  None = 'none',
  AnyAppointmentBooked = 'anyAppointmentBooked',
  OnlineBookingPageViewed = 'onlineBookingPageViewed',
  OnlineBookingSubmitted = 'onlineBookingSubmitted',
  EmailOpened = 'emailOpened',
  InvoicePaid = 'invoicePaid',
  LinkClicked = 'linkClicked',
  Manual = 'manual',
  TaskCompleted = 'taskCompleted',

  // TODO: Set this up
  // MessageReplied = 'messageReplied',
}

export const MARKETING_CAMPAIGN_ENTRY_ENGAGEMENT_DESCRIPTIONS: Record<
  MarketingCampaignStepConversionType,
  string
> = {
  [MarketingCampaignStepConversionType.AnyAppointmentBooked]:
    'Patient booked or rescheduled appointment',
  [MarketingCampaignStepConversionType.OnlineBookingPageViewed]:
    'Patient viewed the online booking page via the link in the email/sms message',
  [MarketingCampaignStepConversionType.OnlineBookingSubmitted]:
    'Patient booked appointment online via the link in the email/sms message',
  [MarketingCampaignStepConversionType.EmailOpened]: 'Patient opened the email',
  [MarketingCampaignStepConversionType.InvoicePaid]: 'Patient paid the invoice',
  [MarketingCampaignStepConversionType.LinkClicked]:
    'Patient clicked a link in the email',
  [MarketingCampaignStepConversionType.Manual]:
    'Staff manually marked the campaign as converted for the entry',
  [MarketingCampaignStepConversionType.TaskCompleted]:
    'Task created by the campaign step is completed',
  [MarketingCampaignStepConversionType.None]: '',
  // [MarketingCampaignStepConversionType.MessageReplied]:
  //   'Patient replied to the sms message',
};

export const MARKETING_CAMPAIGN_STEP_CONVERSION_DESCRIPTIONS: Record<
  MarketingCampaignStepConversionType,
  string
> = {
  [MarketingCampaignStepConversionType.None]: 'No conversion tracking',
  [MarketingCampaignStepConversionType.Manual]:
    'Staff manually mark the campaign as converted for the entry',
  [MarketingCampaignStepConversionType.AnyAppointmentBooked]:
    'Converts if any appointment is booked or rescheduled for the patient',
  [MarketingCampaignStepConversionType.OnlineBookingSubmitted]:
    'Converts if the patient books an appointment online via the link in the email/sms message',
  [MarketingCampaignStepConversionType.OnlineBookingPageViewed]:
    'Converts if the patient views the online booking page via the link in the email/sms message',
  [MarketingCampaignStepConversionType.EmailOpened]:
    'Converts if the patient opens the email',
  [MarketingCampaignStepConversionType.InvoicePaid]:
    'Converts if the invoice is paid',
  [MarketingCampaignStepConversionType.LinkClicked]:
    'Converts if the patient clicks any links the email messages sent by the campaign',
  // [MarketingCampaignStepConversionType.MessageReplied]:
  //   'Converts if the patient replies to the sms message',
  [MarketingCampaignStepConversionType.TaskCompleted]:
    'Converts if the task created by the campaign step is completed',
};

export type AnyMarketingCampaignStepConfig =
  | IAutomatedNotification
  | IGeneratedTask
  | IWebhookAutomationAction
  | IPartnerAutomationAction;

export interface IMarketingCampaignStep<Config = AnyMarketingCampaignStepConfig>
  extends ISoftDelete {
  uid: string;
  name: string;
  config: Config;
  status: MarketingCampaignStepStatus;
  metadata: {
    conversions: number;
    unsubscribes: number;
  };
}

interface IWebhookAutomationAction extends IAutomationResource {
  type: 'webhook';
}

interface IPartnerAutomationAction extends IAutomationResource {
  type: 'partner';
}
